import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyYenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_yen"}/>
}
